/** Détection viewport — mobile et desktop restent dans le même bundle mail. */
export function isMobileMailViewport(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(max-width: 768px)").matches;
}
